// app/javascript/controllers/invoice_revenue_periods_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template", "amount", "total"]

  connect() {
    this.calculate()
  }

  add(event) {
    event.preventDefault()

    const content = this.templateTarget.innerHTML.replaceAll(
      "NEW_REVENUE_PERIOD_RECORD",
      new Date().getTime().toString()
    )

    this.containerTarget.insertAdjacentHTML("beforeend", content)
    this.calculate()
  }

  remove(event) {
    event.preventDefault()

    const row = event.target.closest("[data-revenue-period-row]")
    if (!row) return

    const destroyInput = row.querySelector("input[name*='[_destroy]']")

    if (destroyInput) {
      destroyInput.value = "1"
      row.classList.add("d-none")
    } else {
      row.remove()
    }

    this.calculate()
  }

  calculate() {
    const total = this.amountTargets
      .filter((input) => !input.closest("[data-revenue-period-row]")?.classList.contains("d-none"))
      .reduce((sum, input) => sum + this.numberValue(input.value), 0)

    this.totalTarget.textContent = total.toFixed(2)
  }

  numberValue(value) {
    if (!value) return 0
    return Number(String(value).replace(",", ".")) || 0
  }
}
